import { booleanAttribute, ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { HxBaseControl } from '../../base/hx-base-control';

@Component({
  selector: 'hx-divider',
  standalone: true,
  template: '',
  styleUrls: ['./divider.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'hx-divider',
    '[class.hx-divider--vertical]': 'vertical()',
    '[class.hx-divider--inset]': 'inset()',
    '[class.hx-divider--dashed]': 'variant() === "dashed"',
    '[attr.role]': '"separator"',
    '[attr.aria-orientation]': 'vertical() ? "vertical" : "horizontal"',
    '[attr.aria-hidden]': 'inert() ? true : null',
  },
})
export class HxDivider extends HxBaseControl {
  /** Whether the divider is vertical (default: horizontal) */
  readonly vertical = input(false, { transform: booleanAttribute });
  /** Whether the divider has inset margin (default: false) */
  readonly inset = input(false, { transform: booleanAttribute });
  /** By default, divider is inert and hidden from AT; set inert=false to expose */
  readonly inert = input(true, { transform: booleanAttribute });
  /** The visual style of the divider line (default: continuous) */
  readonly variant = input<'continuous' | 'dashed'>('continuous');
}
